/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Transactions } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get transactions
         * @param {string} [paymentId] Filter by a payment instruction ID.
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [transactionId] Filter by a transaction ID.
         * @param {ListTransactionsTypeEnum} [type] Filter by transaction type. Allowed values are [card, bank]. Case-insensitive.
         * @param {ListTransactionsCardTransactionTypeEnum} [cardTransactionType] Filter by card transaction type. Only applicable for card transactions. Case-insensitive.
         * @param {boolean} [incremental] Filter by whether a card transaction is an incremental (top-up) of an original authorisation. Only applicable for card transactions. Card transactions that cannot be incremental, such as purchases and refunds, match &#x60;incremental&#x3D;false&#x60;.
         * @param {boolean} [refundAuth] Filter by whether a card transaction is a refund authorisation - an authorisation that returns funds to the cardholder. Only applicable for card transactions. &#x60;true&#x60; returns refund authorisations and their reversals; &#x60;false&#x60; returns all other card transactions.
         * @param {ListTransactionsBankTransactionTypeEnum} [bankTransactionType] Filter by bank transaction type. Only applicable for bank transactions. Case-insensitive.
         * @param {ListTransactionsPaymentTypeEnum} [paymentType] Filter by bank payment type. Only applicable for bank transactions. Case-insensitive.
         * @param {Array<string>} [currency] Filter by currency ISO alpha 3 currency code. Supports multiple values.
         * @param {string} [amount] Minimum to maximum amounts for a balance of the listed transactions; split by &lt;code&gt;#&lt;/code&gt; delimiter.
         * @param {Array<ListTransactionsStatusEnum>} [status] Filter by transaction status. Supports multiple values. Allowed values are [pending, completed, rejected, returned, approved, declined]
         * @param {string} [createdAtFrom] Lower boundary for filtering by creation date.
         * @param {string} [createdAtTo] Higher boundary for filtering by creation date.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions: async (paymentId?: string, orderReference?: string, cardId?: string, transactionId?: string, type?: ListTransactionsTypeEnum, cardTransactionType?: ListTransactionsCardTransactionTypeEnum, incremental?: boolean, refundAuth?: boolean, bankTransactionType?: ListTransactionsBankTransactionTypeEnum, paymentType?: ListTransactionsPaymentTypeEnum, currency?: Array<string>, amount?: string, status?: Array<ListTransactionsStatusEnum>, createdAtFrom?: string, createdAtTo?: string, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['orderReference'] = orderReference;
            }

            if (cardId !== undefined) {
                localVarQueryParameter['cardId'] = cardId;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (cardTransactionType !== undefined) {
                localVarQueryParameter['cardTransactionType'] = cardTransactionType;
            }

            if (incremental !== undefined) {
                localVarQueryParameter['incremental'] = incremental;
            }

            if (refundAuth !== undefined) {
                localVarQueryParameter['refundAuth'] = refundAuth;
            }

            if (bankTransactionType !== undefined) {
                localVarQueryParameter['bankTransactionType'] = bankTransactionType;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (currency) {
                localVarQueryParameter['currency'] = currency;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get transactions
         * @param {string} [paymentId] Filter by a payment instruction ID.
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [transactionId] Filter by a transaction ID.
         * @param {ListTransactionsTypeEnum} [type] Filter by transaction type. Allowed values are [card, bank]. Case-insensitive.
         * @param {ListTransactionsCardTransactionTypeEnum} [cardTransactionType] Filter by card transaction type. Only applicable for card transactions. Case-insensitive.
         * @param {boolean} [incremental] Filter by whether a card transaction is an incremental (top-up) of an original authorisation. Only applicable for card transactions. Card transactions that cannot be incremental, such as purchases and refunds, match &#x60;incremental&#x3D;false&#x60;.
         * @param {boolean} [refundAuth] Filter by whether a card transaction is a refund authorisation - an authorisation that returns funds to the cardholder. Only applicable for card transactions. &#x60;true&#x60; returns refund authorisations and their reversals; &#x60;false&#x60; returns all other card transactions.
         * @param {ListTransactionsBankTransactionTypeEnum} [bankTransactionType] Filter by bank transaction type. Only applicable for bank transactions. Case-insensitive.
         * @param {ListTransactionsPaymentTypeEnum} [paymentType] Filter by bank payment type. Only applicable for bank transactions. Case-insensitive.
         * @param {Array<string>} [currency] Filter by currency ISO alpha 3 currency code. Supports multiple values.
         * @param {string} [amount] Minimum to maximum amounts for a balance of the listed transactions; split by &lt;code&gt;#&lt;/code&gt; delimiter.
         * @param {Array<ListTransactionsStatusEnum>} [status] Filter by transaction status. Supports multiple values. Allowed values are [pending, completed, rejected, returned, approved, declined]
         * @param {string} [createdAtFrom] Lower boundary for filtering by creation date.
         * @param {string} [createdAtTo] Higher boundary for filtering by creation date.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransactions(paymentId?: string, orderReference?: string, cardId?: string, transactionId?: string, type?: ListTransactionsTypeEnum, cardTransactionType?: ListTransactionsCardTransactionTypeEnum, incremental?: boolean, refundAuth?: boolean, bankTransactionType?: ListTransactionsBankTransactionTypeEnum, paymentType?: ListTransactionsPaymentTypeEnum, currency?: Array<string>, amount?: string, status?: Array<ListTransactionsStatusEnum>, createdAtFrom?: string, createdAtTo?: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transactions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransactions(paymentId, orderReference, cardId, transactionId, type, cardTransactionType, incremental, refundAuth, bankTransactionType, paymentType, currency, amount, status, createdAtFrom, createdAtTo, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.listTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get transactions
         * @param {TransactionsApiListTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions(requestParameters: TransactionsApiListTransactionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Transactions> {
            return localVarFp.listTransactions(requestParameters.paymentId, requestParameters.orderReference, requestParameters.cardId, requestParameters.transactionId, requestParameters.type, requestParameters.cardTransactionType, requestParameters.incremental, requestParameters.refundAuth, requestParameters.bankTransactionType, requestParameters.paymentType, requestParameters.currency, requestParameters.amount, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listTransactions operation in TransactionsApi.
 * @export
 * @interface TransactionsApiListTransactionsRequest
 */
export interface TransactionsApiListTransactionsRequest {
    /**
     * Filter by a payment instruction ID.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly paymentId?: string

    /**
     * Filter by order reference number.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly orderReference?: string

    /**
     * Filter by a card ID.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly cardId?: string

    /**
     * Filter by a transaction ID.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly transactionId?: string

    /**
     * Filter by transaction type. Allowed values are [card, bank]. Case-insensitive.
     * @type {'card' | 'bank'}
     * @memberof TransactionsApiListTransactions
     */
    readonly type?: ListTransactionsTypeEnum

    /**
     * Filter by card transaction type. Only applicable for card transactions. Case-insensitive.
     * @type {'authorization' | 'purchase' | 'refund' | 'chargeback' | 'reversal'}
     * @memberof TransactionsApiListTransactions
     */
    readonly cardTransactionType?: ListTransactionsCardTransactionTypeEnum

    /**
     * Filter by whether a card transaction is an incremental (top-up) of an original authorisation. Only applicable for card transactions. Card transactions that cannot be incremental, such as purchases and refunds, match &#x60;incremental&#x3D;false&#x60;.
     * @type {boolean}
     * @memberof TransactionsApiListTransactions
     */
    readonly incremental?: boolean

    /**
     * Filter by whether a card transaction is a refund authorisation - an authorisation that returns funds to the cardholder. Only applicable for card transactions. &#x60;true&#x60; returns refund authorisations and their reversals; &#x60;false&#x60; returns all other card transactions.
     * @type {boolean}
     * @memberof TransactionsApiListTransactions
     */
    readonly refundAuth?: boolean

    /**
     * Filter by bank transaction type. Only applicable for bank transactions. Case-insensitive.
     * @type {'bankTransfer' | 'moneyIn' | 'moneyOut' | 'lockFunds' | 'unlockFunds' | 'settlement' | 'rebate' | 'bankFee'}
     * @memberof TransactionsApiListTransactions
     */
    readonly bankTransactionType?: ListTransactionsBankTransactionTypeEnum

    /**
     * Filter by bank payment type. Only applicable for bank transactions. Case-insensitive.
     * @type {'SEPA' | 'INST' | 'FAST' | 'SWIFT' | 'INTRA' | 'TARGET2' | 'TIPS' | 'BACS' | 'OTHER'}
     * @memberof TransactionsApiListTransactions
     */
    readonly paymentType?: ListTransactionsPaymentTypeEnum

    /**
     * Filter by currency ISO alpha 3 currency code. Supports multiple values.
     * @type {Array<string>}
     * @memberof TransactionsApiListTransactions
     */
    readonly currency?: Array<string>

    /**
     * Minimum to maximum amounts for a balance of the listed transactions; split by &lt;code&gt;#&lt;/code&gt; delimiter.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly amount?: string

    /**
     * Filter by transaction status. Supports multiple values. Allowed values are [pending, completed, rejected, returned, approved, declined]
     * @type {Array<'pending' | 'completed' | 'rejected' | 'returned' | 'approved' | 'declined'>}
     * @memberof TransactionsApiListTransactions
     */
    readonly status?: Array<ListTransactionsStatusEnum>

    /**
     * Lower boundary for filtering by creation date.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly createdAtFrom?: string

    /**
     * Higher boundary for filtering by creation date.
     * @type {string}
     * @memberof TransactionsApiListTransactions
     */
    readonly createdAtTo?: string

    /**
     * Page number for pagination.
     * @type {number}
     * @memberof TransactionsApiListTransactions
     */
    readonly pageNumber?: number

    /**
     * Page size for pagination.
     * @type {number}
     * @memberof TransactionsApiListTransactions
     */
    readonly pageSize?: number
}

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Get transactions
     * @param {TransactionsApiListTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public listTransactions(requestParameters: TransactionsApiListTransactionsRequest = {}, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).listTransactions(requestParameters.paymentId, requestParameters.orderReference, requestParameters.cardId, requestParameters.transactionId, requestParameters.type, requestParameters.cardTransactionType, requestParameters.incremental, requestParameters.refundAuth, requestParameters.bankTransactionType, requestParameters.paymentType, requestParameters.currency, requestParameters.amount, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListTransactionsTypeEnum = {
    Card: 'card',
    Bank: 'bank'
} as const;
export type ListTransactionsTypeEnum = typeof ListTransactionsTypeEnum[keyof typeof ListTransactionsTypeEnum];
/**
 * @export
 */
export const ListTransactionsCardTransactionTypeEnum = {
    Authorization: 'authorization',
    Purchase: 'purchase',
    Refund: 'refund',
    Chargeback: 'chargeback',
    Reversal: 'reversal'
} as const;
export type ListTransactionsCardTransactionTypeEnum = typeof ListTransactionsCardTransactionTypeEnum[keyof typeof ListTransactionsCardTransactionTypeEnum];
/**
 * @export
 */
export const ListTransactionsBankTransactionTypeEnum = {
    BankTransfer: 'bankTransfer',
    MoneyIn: 'moneyIn',
    MoneyOut: 'moneyOut',
    LockFunds: 'lockFunds',
    UnlockFunds: 'unlockFunds',
    Settlement: 'settlement',
    Rebate: 'rebate',
    BankFee: 'bankFee'
} as const;
export type ListTransactionsBankTransactionTypeEnum = typeof ListTransactionsBankTransactionTypeEnum[keyof typeof ListTransactionsBankTransactionTypeEnum];
/**
 * @export
 */
export const ListTransactionsPaymentTypeEnum = {
    Sepa: 'SEPA',
    Inst: 'INST',
    Fast: 'FAST',
    Swift: 'SWIFT',
    Intra: 'INTRA',
    Target2: 'TARGET2',
    Tips: 'TIPS',
    Bacs: 'BACS',
    Other: 'OTHER'
} as const;
export type ListTransactionsPaymentTypeEnum = typeof ListTransactionsPaymentTypeEnum[keyof typeof ListTransactionsPaymentTypeEnum];
/**
 * @export
 */
export const ListTransactionsStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Rejected: 'rejected',
    Returned: 'returned',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type ListTransactionsStatusEnum = typeof ListTransactionsStatusEnum[keyof typeof ListTransactionsStatusEnum];
